
<form novalidate (ngSubmit)="save()" #formPetDental="ngForm">
    <div class="card-body mx-0 pt-4">
        <div class="row">
            
                <div class="col-lg-3 separator-vertical my-0">
                    <div class="form-group">
                        <h6>Patient Vital</h6>
                    </div>

                    <table class="table table-sm">
                        <tbody>
                            <tr>
                                <td class="form-label-sm">Respiration <small>Cycles</small>:</td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag3"
                                        [(ngModel)]="petService.pet_vitals.tag3" />
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">Heart <small>Rate/Min</small>:</td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag4"
                                        [(ngModel)]="petService.pet_vitals.tag4" />
                                </td>
                            </tr>
                            
                            <tr>
                                <td class="form-label-sm">Temperature:</td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag2"
                                        [(ngModel)]="petService.pet_vitals.tag2" />
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">SpO<sub>2</sub>:</td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag30"
                                        [(ngModel)]="petService.pet_vitals.tag30" />
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">SpOC<sub>2</sub>:</td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag31"
                                        [(ngModel)]="petService.pet_vitals.tag31" />
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">BP <br><small>Sys/Dia (mm Hg)</small>:</td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag5"
                                        [(ngModel)]="petService.pet_vitals.tag5" />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div> 

                <div class="col-lg-3 separator-vertical my-0">
                    <div class="form-group">
                        <h6>Anesthesia</h6>
                    </div>

                    <table class="table table-sm">
                        <tbody>
                            <tr>
                                <td class="form-label-sm" style="width: 20%;">Start Time:</td>
                                <td style="width: 40%;">
                                    <input type="time" class="form-control form-control-sm" name="_tag46" [(ngModel)]="petService.pet_vitals.tag46"/>
                                </td>
                                <td style="width: 40%;"></td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">End Time:</td>
                                <td>
                                    <input type="time" class="form-control form-control-sm" name="_tag47" [(ngModel)]="petService.pet_vitals.tag47"/>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">Anesthetic Gas:</td>
                                <td>
                                    <select class="form-control form-select-sm" name="_tag45"
                                    [(ngModel)]="petService.pet_vitals.tag45">
                                        <option value=""></option>
                                        <option [value]="item.description" *ngFor="let item of MONITOR_ANES">
                                            {{ item.description }}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" />
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">Fluids:</td>
                                <td>
                                    <select class="form-control form-select-sm" name="_tag27"
                                        [(ngModel)]="petService.pet_vitals.tag27">
                                        <option value=""></option>
                                        <option [value]="item.description" *ngFor="let item of MONITOR_FLUIDS">
                                            {{ item.description }}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag27bis"
                                        [(ngModel)]="petService.pet_vitals.tag27bis" />
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">Breathing:</td>
                                <td>
                                    <select class="form-control form-select-sm" name="_tag28"
                                        [(ngModel)]="petService.pet_vitals.tag28">
                                        <option value=""></option>
                                        <option [value]="item.description" *ngFor="let item of MONITOR_BREATH">
                                            {{ item.description }}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag28bis"
                                        [(ngModel)]="petService.pet_vitals.tag28bis" />
                                </td> 
                            </tr>
                        </tbody>
                    </table>

                </div>

                <div class="col-lg-3 separator-vertical my-0">
                    <div class="form-group">
                        <h6>Conditions Factors</h6>
                    </div>

                    <table class="table table-sm">
                        <tbody>
                            <tr>
                                <td class="form-label-sm">Hydration:</td>
                                <td>
                                    <select class="form-control form-select-sm" name="_tag29" [(ngModel)]="petService.pet_vitals.tag29" >
                                        <option value=""></option>
                                        <option [value]="item.description" *ngFor="let item of HYDRATION">
                                            {{ item.description }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                           
                            <tr>
                                <td class="form-label-sm">Lung Sound:</td>
                                <td>
                                    <select class="form-control form-select-sm" name="_tag32" [(ngModel)]="petService.pet_vitals.tag32">
                                        <option value=""></option>
                                        <option [value]="item.description" *ngFor="let item of LUNG_SOUNDS">
                                            {{ item.description }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">Heart Sound:</td>
                                <td>
                                    <select class="form-control form-select-sm" name="_tag33" [(ngModel)]="petService.pet_vitals.tag33">
                                        <option value=""></option>
                                        <option [value]="item.description" *ngFor="let item of HEARTH_SOUNDS">
                                            {{ item.description }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <div class="col-lg-3 my-0">
                    <div class="form-group">
                        <h6>Procedure</h6>
                    </div>

                    <table class="table table-sm">
                        <tbody>
                            <tr>
                                <td class="form-label-sm" style="width: 20%;">Procedure:</td>
                                <td style="width: 80%;">
                                    <select class="form-control form-select-sm" autocomplete="off" name="_tag40"
                                        [(ngModel)]="petService.pet_vitals.tag40">
                                        <option value=""></option>
                                        <option [value]="item.code_name" *ngFor="let item of catalogService.dental_code">
                                            {{ item.code_name }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">Start Time:</td>
                                <td>
                                    <input type="time" class="form-control form-control-sm" autocomplete="off" name="_tag41"
                                        [(ngModel)]="petService.pet_vitals.tag41" />
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">End Time:</td>
                                <td>
                                    <input type="time" class="form-control form-control-sm" autocomplete="off" name="_tag42"
                                        [(ngModel)]="petService.pet_vitals.tag42" />
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">Suture:</td>
                                <td>
                                    <select class="form-control form-select-sm" autocomplete="off" name="_tag43"
                                        [(ngModel)]="petService.pet_vitals.tag43">
                                        <option value=""></option>
                                        <option [value]="item.item_code" *ngFor="let item of catalogService.suture_codes">
                                            {{ item.item_desc }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td class="form-label-sm">Other:</td>
                                <td>
                                    <select class="form-control form-select-sm" autocomplete="off" name="_tag44"
                                        [(ngModel)]="petService.pet_vitals.tag44">
                                        <option value=""></option>
                                        <option [value]="item.item_code" *ngFor="let item of catalogService.suture_codes">
                                            {{ item.item_desc }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>  
        </div> 
    </div>
    <div class="card-footer text-right py-2">
        <button type="submit" class="btn btn-primary btn-sm" [disabled]="formPetDental.invalid">
            <i class="fas fa-save"></i> Save Changes
        </button>
    </div>
</form> 

    <div class="col-lg-12 my-2 separator separator-dashed"></div>
 
 
    <div class="row ml-3 mr-3 mb-0">
        <div class="form-group col-12">
            <h6 mr-4>Exam Note</h6>
            
            <div class="d-flex justify-content-between">
                <div class="btn-group btn-group-toggle">
                    <label class="btn btn-secondary" [class.active]="exam_note_type === 'Med'" (click)="exam_note_type = 'Med'">
                      Med
                    </label>
                    <label class="btn btn-secondary" [class.active]="exam_note_type === 'Disch'" (click)="exam_note_type = 'Disch'">
                      Disch
                    </label>
                    <label class="btn btn-secondary" [class.active]="exam_note_type === 'Recp'" (click)="exam_note_type = 'Recp'">
                      Recp
                    </label>
                    <label class="btn btn-secondary" [class.active]="exam_note_type === 'Hosp'" (click)="exam_note_type = 'Hosp'">
                      Hosp
                    </label>
                </div>
            
               
            </div>
        </div>

        <div class="form-group col-12">
            <textarea class="form-control form-control-sm" [(ngModel)]="exam_note" name="_exam_note"
                required cols="30" rows="8"></textarea>
        </div>
        <div class="form-group col-12 text-right py-2">
            <button class="btn btn-primary btn-sm" (click)="saveExamNote()">
                <i class="fas fa-save"></i> Save Note
            </button>
        </div>
    </div>

    <div class="col-lg-12 my-2 separator separator-dashed"></div>

    <!-- Procedure -->
    <!-- <div class="card-body mt-0 pt-2 mb-0">
        <form novalidate (ngSubmit)="addProcedure()" #formClientInfo="ngForm">
            <div class="table-responsive max-h-500px">
                <table class="table table-bordered  table-sm rounded">
                    <thead class="thead-light">
                        <tr>
                            <th style="width: 20%;">Procedure</th>
                            <th style="width: 15%;">
                                Type
                            </th>
                            <th>
                                Note
                            </th> 
                            <th class="text-center min-w-50px" style="width: 5%;"></th>
                        </tr>
                    </thead>
                    <tbody> 
                        <tr  *ngFor="let item of procedure_list; let i = index">
                            <td>{{ item.procedure }}</td>
                            <td>{{ item.code_type }}</td>
                            <td>{{ item.note }}</td> 
                            <td class="text-center">
                                <button type="button" class="btn btn-icon btn-danger btn-sm" 
                                (click)="delete(i)">
                                <i class="fas fa-trash icon-sm"></i>
                                 </button>
                            </td>
                        </tr>
                        <tr>
                            <td> 
                                <input type="text" class="form-control" required
                                    *ngIf="this.petService.pet.active !== 'N'"
                                    placeholder="Type a code name/category/subcategory/vendor/desc/manuf"
                                    autocomplete="off" name="_code_name" (keydown)="search($event)"
                                    [(ngModel)]="filterText">
                                <div class="list-group button-container" style="max-height: 200px;overflow-y: auto;"
                                    *ngIf="buscador_activo">
                                    <button type="button" class="list-group-item list-group-item-action"
                                        *ngFor="let item of suggestedWordsArray"
                                        (click)="select(item); statusSelect.click();">
                                        {{ item.code_name + " " + item.procedure_desc }}
                                    </button>
                                </div>
                            </td> 
                            <td> 
                                <div style="max-width:200px ;">
                                    <select class="form-control" name="_Status" id="_Status"
                                     [(ngModel)]="txtchar" required #statusSelect
                                    >
                                    <option value="" selected></option>
                                    <option value="R">R - Request</option>
                                    <option value="D">D - Done</option>
                                    <option value="T">T - Treatment</option>
                                    <option value="F">F - Refund</option>
                                    <option value="W">W - Working</option>
                                    <option value="C">C - Client request</option>
                                    <option value="S">S - Suggested</option>
                                    <option value="P">P - Pharm Label</option>
                                    </select>
                                </div>
                            </td>
                            <td>
                                <input type="text" class="form-control" name="_procnote" [(ngModel)]="procedure_details.note">
                            </td>
                            <td class="text-center">
                                <button type="submit" class="btn btn-sm btn-success mt-1" 
                                    [disabled]="formClientInfo.invalid">
                                    <i class="fas fa-plus icon-sm"></i> Add Proc.
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>

       

    </div>
    
 
 -->